import script from "./TimelineTrackArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelineTrackArea.vue?vue&type=script&setup=true&lang=js"

import "./TimelineTrackArea.vue?vue&type=style&index=0&id=ae87132e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae87132e"]])

export default __exports__